module.exports = __webpack_public_path__ + "img/kx5200-5.1a42bafb.png";